import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import BasicBreadcrumbs from './BasicBreadcrumbs';
import ClientProvider from './client';
export default createDemo(import.meta.url, BasicBreadcrumbs, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/breadcrumbs/demos/basic/BasicBreadcrumbs.tsx",
    "fileName": "BasicBreadcrumbs.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport Typography from '@mui/material/Typography';\nimport Breadcrumbs from '@mui/material/Breadcrumbs';\nimport Link from '@mui/material/Link';\n\nfunction handleClick(event: React.MouseEvent<HTMLDivElement, MouseEvent>) {\n  event.preventDefault();\n  console.info('You clicked a breadcrumb.');\n}\n\nexport default function BasicBreadcrumbs() {\n  return (\n    <div role=\"presentation\" onClick={handleClick}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Breadcrumbs aria-label=\"breadcrumb\">\n        <Link underline=\"hover\" color=\"inherit\" href=\"/\">\n          MUI\n        </Link>\n        <Link\n          underline=\"hover\"\n          color=\"inherit\"\n          href=\"/material-ui/getting-started/installation/\"\n        >\n          Core\n        </Link>\n        <Typography sx={{ color: 'text.primary' }}>Breadcrumbs</Typography>\n      </Breadcrumbs>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </div>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 29,
        "focusedLines": 13,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport Typography from '@mui/material/Typography';\nimport Breadcrumbs from '@mui/material/Breadcrumbs';\nimport Link from '@mui/material/Link';\n\nfunction handleClick(event: React.MouseEvent<HTMLDivElement, MouseEvent>) {\n  event.preventDefault();\n  console.info('You clicked a breadcrumb.');\n}\n\nexport default function BasicBreadcrumbs() {\n  return (\n    <div role=\"presentation\" onClick={handleClick}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <Breadcrumbs aria-label=\"breadcrumb\">\n        <Link underline=\"hover\" color=\"inherit\" href=\"/\">\n          MUI\n        </Link>\n        <Link\n          underline=\"hover\"\n          color=\"inherit\"\n          href=\"/material-ui/getting-started/installation/\"\n        >\n          Core\n        </Link>\n        <Typography sx={{ color: 'text.primary' }}>Breadcrumbs</Typography>\n      </Breadcrumbs>\n"
      ],
      [
        "span",
        "frame",
        "    </div>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 14
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Breadcrumbs"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "aria-label"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "breadcrumb",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 15
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Link"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "underline"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "hover",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "color"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "inherit",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "href"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "/",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 16
            },
            "          MUI"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 17
            },
            [
              "        </",
              [
                "span",
                "pl-c1 di-jsx",
                "Link"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 18
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Link"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 19
            },
            [
              "          ",
              [
                "span",
                "pl-e di-ak",
                "underline"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "hover",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 20
            },
            [
              "          ",
              [
                "span",
                "pl-e di-ak",
                "color"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "inherit",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 21
            },
            [
              "          ",
              [
                "span",
                "pl-e di-ak",
                "href"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "/material-ui/getting-started/installation/",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 22
            },
            "        >"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 23
            },
            "          Core"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 24
            },
            [
              "        </",
              [
                "span",
                "pl-c1 di-jsx",
                "Link"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 25
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Typography"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "sx"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "di-op di-jv",
                "color"
              ],
              ": ",
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ],
                  "text.primary",
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ]
                ]
              ],
              " }",
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">Breadcrumbs</",
              [
                "span",
                "pl-c1 di-jsx",
                "Typography"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 26
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "Breadcrumbs"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 29,
    "focusedLines": 13,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/Typography",
      "@mui/material/Breadcrumbs",
      "@mui/material/Link"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
